export enum EUserGuide {
    NEED_HELP = 'I still need help',
    GOT_IT = 'I got it'
}
